// ==============================|| OVERRIDES - DATA GRID ||============================== //
import Colors from './StopColors';
import { gridClasses } from '@mui/x-data-grid';
import { alpha } from '@mui/material/styles';

const ODD_OPACITY = 0.2;

export default function DataGrid(theme) {
  return {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          [`& .${gridClasses.row}.even`]: {
            //backgroundColor: theme.palette.grey[200],
            backgroundColor: '#ceebfd',
            '&:hover, &.Mui-hovered': {
              backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
              '@media (hover: none)': {
                backgroundColor: 'transparent',
              },
            },
            '&.Mui-selected': {
              backgroundColor: alpha(
                theme.palette.primary.main,
                ODD_OPACITY + theme.palette.action.selectedOpacity
              ),
              '&:hover, &.Mui-hovered': {
                backgroundColor: alpha(
                  theme.palette.primary.main,
                  ODD_OPACITY +
                    theme.palette.action.selectedOpacity +
                    theme.palette.action.hoverOpacity
                ),
                '@media (hover: none)': {
                  backgroundColor: alpha(
                    theme.palette.primary.main,
                    ODD_OPACITY + theme.palette.action.selectedOpacity
                  ),
                },
              },
            },
          },
          '&:hover': {
            color: Colors.black,
            backgroundColor: Colors.white,
          },
        },
        columnHeader: {
          padding: 'unset',
        },
        columnHeaders: {
          padding: '0px 6px 0px 6px',
          backgroundColor: '#747070',
          borderTopLeftRadius: 'unset',
          borderTopRightRadius: 'unset',
        },
        columnHeaderTitle: {
          fontSize: '15px',
          whiteSpace: 'normal',
          lineHeight: '20px',
          color: Colors.white,
        },
        row: {
          background: Colors.white,
        },
        cell: {
          padding: '0px 5px',
        },
        cellContent: {
          fontSize: '15px',
          whiteSpace: 'normal',
          lineHeight: '18px',
          padding: '15px 0px',
        },
        iconButtonContainer: {
          width: 'unset',
        },
        iconSeparator: {
          display: 'none',
        },
        footerContainer: {
          backgroundColor: '#D3D3D3',
          height: '44px',
          minHeight: 'unset',
        },
      },
    },
  };
}
